import React, { Component } from 'react';
import {
    InputTextTagStyles,
    InputTextTagWrapperStyles,
    SearchTag,
    SearchTags,
    TabPageStyles,
} from './Styled';
import TabPages, { TabStyle } from '../TabBarPages/TabBarPages';
import { TabPage } from '../TabBarPages/Styled';
import InputText from '../FormInputText/FormInputText';
import { MainContentBg, TabContent } from '../../../styles/Styled';
import IconNew from '../IconNew/IconNew';
import { ClearFloats } from '../BaseTemplate/Styled';

class LeadManagmentSearchTabBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tagInputValue: '',
            tags: [],
        };
    }

    tagChangeHandler = (e) => {
        this.setState({
            tagInputValue: e.target.value,
        });
    };

    tagEnterHandler = () => {
        this.setState((prevState) => {
            let tags = [...prevState.tags];
            tags.push(this.state.tagInputValue);
            return {
                tags,
                tagInputValue: '',
            };
        });
    };

    removeTag = (index) => {
        let tags = [...this.state.tags];
        tags.splice(index, 1);
        this.setState({ tags });
    };

    render() {
        return (
            <MainContentBg>
                <TabContent margin={1}>
                    <TabPages
                        theme={TabStyle.MyNetworksSearchTab}
                        defaultPageIndex={this.props.defaultIndex}
                        Type="MyNetworkSearchTabBar"
                    >
                        <TabPage title="Connections" styled={TabPageStyles}>
                            <InputText
                                id="tagsInput"
                                name="tagsInput"
                                type="text"
                                onInput={this.tagChangeHandler}
                                value={this.state.tagInputValue}
                                onEnter={this.tagEnterHandler}
                                styled={InputTextTagStyles}
                                wrapperStyled={InputTextTagWrapperStyles}
                                placeholder="Search name or #hashtag"
                            >
                                <IconNew
                                    bp1="-407"
                                    bp2="-159"
                                    iwidth="25"
                                    iheight="25"
                                />
                            </InputText>

                            <SearchTags>
                                {this.state.tags.map((tag, index) => (
                                    <SearchTag key={index}>
                                        <IconNew
                                            bp1="-467"
                                            bp2="-60"
                                            iwidth="10"
                                            iheight="15"
                                        />
                                        {tag}
                                        <i
                                            onClick={(e) =>
                                                this.removeTag(index)
                                            }
                                        />
                                    </SearchTag>
                                ))}
                            </SearchTags>
                            <ClearFloats />
                        </TabPage>

                        <TabPage title="People Suggestion" styled={TabPageStyles}>
                            <InputText
                                id="tagsInput"
                                name="tagsInput"
                                type="text"
                                onInput={this.tagChangeHandler}
                                value={this.state.tagInputValue}
                                onEnter={this.tagEnterHandler}
                                styled={InputTextTagStyles}
                                wrapperStyled={InputTextTagWrapperStyles}
                                placeholder="Search name or #hashtag"
                            >
                                <IconNew
                                    bp1="-407"
                                    bp2="-159"
                                    iwidth="25"
                                    iheight="25"
                                />
                            </InputText>

                            <SearchTags>
                                {this.state.tags.map((tag, index) => (
                                    <SearchTag key={index}>
                                        <IconNew
                                            bp1="-467"
                                            bp2="-60"
                                            iwidth="10"
                                            iheight="15"
                                        />
                                        {tag}
                                        <i
                                            onClick={(e) =>
                                                this.removeTag(index)
                                            }
                                        />
                                    </SearchTag>
                                ))}
                            </SearchTags>
                            <ClearFloats />
                        </TabPage>

                        <TabPage title="Groups" styled={TabPageStyles}>
                            <InputText
                                id="tagsInput"
                                name="tagsInput"
                                type="text"
                                onInput={this.tagChangeHandler}
                                value={this.state.tagInputValue}
                                onEnter={this.tagEnterHandler}
                                styled={InputTextTagStyles}
                                wrapperStyled={InputTextTagWrapperStyles}
                                placeholder="Search name or #hashtag"
                            >
                                <IconNew
                                    bp1="-407"
                                    bp2="-159"
                                    iwidth="25"
                                    iheight="25"
                                />
                            </InputText>

                            <SearchTags>
                                {this.state.tags.map((tag, index) => (
                                    <SearchTag key={index}>
                                        <IconNew
                                            bp1="-467"
                                            bp2="-60"
                                            iwidth="10"
                                            iheight="15"
                                        />
                                        {tag}
                                        <i
                                            onClick={(e) =>
                                                this.removeTag(index)
                                            }
                                        />
                                    </SearchTag>
                                ))}
                            </SearchTags>

                            <ClearFloats />
                        </TabPage>
                        <TabPage title="Group Suggestion" styled={TabPageStyles}>
                            <InputText
                                id="tagsInput"
                                name="tagsInput"
                                type="text"
                                onInput={this.tagChangeHandler}
                                value={this.state.tagInputValue}
                                onEnter={this.tagEnterHandler}
                                styled={InputTextTagStyles}
                                wrapperStyled={InputTextTagWrapperStyles}
                                placeholder="Search name or #hashtag"
                            >
                               <IconNew
                                    bp1="-407"
                                    bp2="-159"
                                    iwidth="25"
                                    iheight="25"
                                />
                            </InputText>

                            <SearchTags>
                                {this.state.tags.map((tag, index) => (
                                    <SearchTag key={index}>
                                        <IconNew
                                            bp1="-467"
                                            bp2="-60"
                                            iwidth="10"
                                            iheight="15"
                                        />
                                        {tag}
                                        <i
                                            onClick={(e) =>
                                                this.removeTag(index)
                                            }
                                        />
                                    </SearchTag>
                                ))}
                            </SearchTags>

                            <ClearFloats />
                        </TabPage>
                        <TabPage title="Followers" styled={TabPageStyles}>
                            <InputText
                                id="tagsInput"
                                name="tagsInput"
                                type="text"
                                onInput={this.tagChangeHandler}
                                value={this.state.tagInputValue}
                                onEnter={this.tagEnterHandler}
                                styled={InputTextTagStyles}
                                wrapperStyled={InputTextTagWrapperStyles}
                                placeholder="Search name or #hashtag"
                            >
                                <IconNew
                                    bp1="-407"
                                    bp2="-159"
                                    iwidth="25"
                                    iheight="25"
                                />
                            </InputText>

                            <SearchTags>
                                {this.state.tags.map((tag, index) => (
                                    <SearchTag key={index}>
                                        <IconNew
                                            bp1="-467"
                                            bp2="-60"
                                            iwidth="10"
                                            iheight="15"
                                        />
                                        {tag}
                                        <i
                                            onClick={(e) =>
                                                this.removeTag(index)
                                            }
                                        />
                                    </SearchTag>
                                ))}
                            </SearchTags>

                            <ClearFloats />
                        </TabPage>
                        <TabPage title="Followings" styled={TabPageStyles}>
                            <InputText
                                id="tagsInput"
                                name="tagsInput"
                                type="text"
                                onInput={this.tagChangeHandler}
                                value={this.state.tagInputValue}
                                onEnter={this.tagEnterHandler}
                                styled={InputTextTagStyles}
                                wrapperStyled={InputTextTagWrapperStyles}
                                placeholder="Search name or #hashtag"
                            >
                                <IconNew
                                    bp1="-407"
                                    bp2="-159"
                                    iwidth="25"
                                    iheight="25"
                                />
                            </InputText>

                            <SearchTags>
                                {this.state.tags.map((tag, index) => (
                                    <SearchTag key={index}>
                                        <IconNew
                                            bp1="-467"
                                            bp2="-60"
                                            iwidth="10"
                                            iheight="15"
                                        />
                                        {tag}
                                        <i
                                            onClick={(e) =>
                                                this.removeTag(index)
                                            }
                                        />
                                    </SearchTag>
                                ))}
                            </SearchTags>

                            <ClearFloats />
                        </TabPage>
                        <TabPage title="Requests" styled={TabPageStyles}>
                            <InputText
                                id="tagsInput"
                                name="tagsInput"
                                type="text"
                                onInput={this.tagChangeHandler}
                                value={this.state.tagInputValue}
                                onEnter={this.tagEnterHandler}
                                styled={InputTextTagStyles}
                                wrapperStyled={InputTextTagWrapperStyles}
                                placeholder="Search name or #hashtag"
                            >
                                <IconNew
                                    bp1="-407"
                                    bp2="-159"
                                    iwidth="25"
                                    iheight="25"
                                />
                            </InputText>

                            <SearchTags>
                                {this.state.tags.map((tag, index) => (
                                    <SearchTag key={index}>
                                        <IconNew
                                            bp1="-467"
                                            bp2="-60"
                                            iwidth="10"
                                            iheight="15"
                                        />
                                        {tag}
                                        <i
                                            onClick={(e) =>
                                                this.removeTag(index)
                                            }
                                        />
                                    </SearchTag>
                                ))}
                            </SearchTags>

                            <ClearFloats />
                        </TabPage>
                    </TabPages>
                </TabContent>
            </MainContentBg>
        );
    }
}

export default LeadManagmentSearchTabBar;
